<template>
<div class="container">
  <div class="main">
    <div class="thumb-example">

      <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop">
        <swiper-slide class="slide-2" 
          v-for="(item,i) in picData" :key="i"
          :style="{ 'background-image': 'url('+ item +')'}"   
        ></swiper-slide>
        <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
        <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
      </swiper>
      <!-- swiper2 Thumbs -->
      <swiper class="swiper gallery-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs">
        <swiper-slide class="slide-2" v-for="(item,i) in picData" :key="i" 
          :style="{ 'background-image': 'url('+ item +')'}">  
        </swiper-slide>
      </swiper>

    </div>
  </div>
</div>

</template>

<script>
  import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
  import 'swiper/css/swiper.css'
  export default {
    name: 'swiper-example-thumbs-gallery',
    title: 'Thumbs gallery with Two-way control',
    components: {
      Swiper,
      SwiperSlide
    },
    data() {
      return {
        swiperOptionTop: {
          loop: true,
          loopedSlides: 5, // looped slides should be the same
          spaceBetween: 10,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          lazy: {
            loadPrevNext: true
          },
        },
        swiperOptionThumbs: {
          loop: true,
          loopedSlides: 5, // looped slides should be the same
          spaceBetween: 10,
          centeredSlides: true,
          slidesPerView: 'auto',
          touchRatio: 0.2,
          slideToClickedSlide: true ,
        } ,
        picData : [
          'http://images.dixcel.cn/2015CTCC-R6上海嘉定/1.jpg',
          'http://images.dixcel.cn/2015CTCC-R6上海嘉定/2.jpg',
          'http://images.dixcel.cn/2015CTCC-R6上海嘉定/3.jpg',
          'http://images.dixcel.cn/2015CTCC-R6上海嘉定/4.jpg',
          'http://images.dixcel.cn/2015CTCC-R6上海嘉定/5.jpg',
          'http://images.dixcel.cn/2015CTCC-R6上海嘉定/6.jpg',
          'http://images.dixcel.cn/2015CTCC-R6上海嘉定/7.jpg',
          'http://images.dixcel.cn/2015CTCC-R6上海嘉定/8.jpg',
          'http://images.dixcel.cn/2015CTCC-R6上海嘉定/9.jpg',
          'http://images.dixcel.cn/2015CTCC-R6上海嘉定/10.jpg',
          'http://images.dixcel.cn/2015CTCC-R6上海嘉定/11.jpg',
          'http://images.dixcel.cn/2015CTCC-R6上海嘉定/12.jpg',
          'http://images.dixcel.cn/2015CTCC-R6上海嘉定/13.jpg',
          'http://images.dixcel.cn/2015CTCC-R6上海嘉定/14.jpg',
          'http://images.dixcel.cn/2015CTCC-R6上海嘉定/15.jpg',
          'http://images.dixcel.cn/2015CTCC-R6上海嘉定/16.jpg',
        ]
      }
    },
    mounted() {
      this.$nextTick(() => {
        const swiperTop = this.$refs.swiperTop.$swiper
        const swiperThumbs = this.$refs.swiperThumbs.$swiper
        swiperTop.controller.control = swiperThumbs
        swiperThumbs.controller.control = swiperTop
      })
    }
  }
</script>

<style lang="stylus" scoped>
  .container
    background-color : #000
    .box_one 
      width: 100%;

    .box_bottom
      width: 100%;
      background-color #000


  .main {
    margin-bottom: 5px;
    width: 1003px;
    background-color: #fff;
    margin: 0 auto;
    position: relative;
    box-sizing: border-box;
    padding: 62px 50px 52px;
  }

  .thumb-example {
    height: 680px;
    background-color: $black;
  }
  .swiper {
    .swiper-slide {
      background-size: 100%;
      background-position: center center;
      background-repeat no-repeat
    }
    &.gallery-top {
      height: 80%;
      width: 100%;
    }
    &.gallery-thumbs {
      height: 20%;
      box-sizing: border-box;
      padding: $gap 0;
    }
    &.gallery-thumbs .swiper-slide {
      width: 20%;
      height: 100%;
      opacity: 0.4;
    }
    &.gallery-thumbs .swiper-slide-active {
      opacity: 1;
    }
  }
</style>
